

import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import "react-confirm-alert/src/react-confirm-alert.css";
import { translations } from "../../../../translate.js";

let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;

class ShowEFAWATEERcomData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: 0,
            errorMsg: "",
            data: this.props.data,
            showExportOrder:
                this.props.viewPage == undefined ? this.props.showExportOrder : 0,
            distributorData: []
        };
    }



    render() {
        console.log("orderData", this.state.data);
        return (
            <div className="view-modal-style">
                <div className="sidebar-header-view">
                    <Row>
                        <Col lg={10} md={10} sm={10} xs={10}>
                            <div className="p-0 main-color-1  sidebar-header-title">
                                {Strings["Order #"] + " " + "(" + this.state.data.orderId + ")"}
                            </div>
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2} className="text-right">
                            <HighlightOffIcon
                                onClick={this.props.handleCloseSideBar}
                                className="modal-close-icon"
                            />
                        </Col>
                    </Row>
                </div>
                <div className="sidebar-body-view">

                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>

                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column mb-2"

                            >
                                <Col className="text-bold" lg={12} md={12} sm={12} xs={12}>
                                    {Strings["Order #"]}
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {this.state.data["orderId"]}

                                </Col>
                            </Col>

                        </div>
                    </div>
                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>

                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column mb-2"

                            >
                                <Col className="text-bold" lg={12} md={12} sm={12} xs={12}>
                                    {Strings["Category"]}
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {this.state.data["billerCategory"]}

                                </Col>
                            </Col>

                        </div>
                    </div>
                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>

                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column mb-2"

                            >
                                <Col className="text-bold" lg={12} md={12} sm={12} xs={12}>
                                    {Strings["Biller"]}
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {this.state.data["billerName"]}

                                </Col>
                            </Col>

                        </div>
                    </div>
                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>

                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column mb-2"

                            >
                                <Col className="text-bold" lg={12} md={12} sm={12} xs={12}>
                                    {Strings["Service Name"]}
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {this.state.data["serviceType"]}

                                </Col>
                            </Col>

                        </div>
                    </div>
                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>

                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column mb-2"

                            >
                                <Col className="text-bold" lg={12} md={12} sm={12} xs={12}>
                                    {Strings["Subscription Id"]}
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {this.state.data["subscriptionId"]}

                                </Col>
                            </Col>

                        </div>
                    </div>
                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>

                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column mb-2"

                            >
                                <Col className="text-bold" lg={12} md={12} sm={12} xs={12}>
                                    {Strings["Distributor Name"]}
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {this.state.data["distName"]}

                                </Col>
                            </Col>

                        </div>
                    </div>
                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>

                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column "

                            >
                                <Col className="text-bold" lg={12} md={12} sm={12} xs={12}>
                                    {Strings["POS Name"]}
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {this.state.data["posName"]}

                                </Col>
                            </Col>

                        </div>
                    </div>
                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>

                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column "

                            >
                                <Col className="text-bold" lg={12} md={12} sm={12} xs={12}>
                                    {Strings["Date"]}
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {this.state.data["entryDate"]}

                                </Col>
                            </Col>

                        </div>
                    </div>



                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>

                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column mb-2"

                            >
                                <Col className="text-bold" lg={12} md={12} sm={12} xs={12}>
                                    {Strings["Result"]}
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {this.state.data["result"]}

                                </Col>
                            </Col>

                        </div>
                    </div>



                    <div className="view-purchase-main-fields" style={{ marginBottom: "10px" }}>
                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap-2 flex-column  mb-3"

                            >
                                <Col lg={12} md={12} sm={12} xs={12} className="text-bold">
                                    {Strings["Prices"]}
                                </Col>

                            </Col>
                        </div>
                        <hr style={{ borderTop: "1px solid #dee2e6" }} />
                        <div className="view-purchase-main-fields-row" >
                            <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="main-font-1 font-w-500 d-flex justify-content-between gap- flex-column "

                            >
                                {localStorage.getItem('USER_LEVEL') == 1 ? <>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["Invoice Value Before Jd"]} :
                                        </span>
                                        {this.state.data["amountBeforeJd"] || "-"} JD
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["Invoice Value Before"]} :
                                        </span>
                                        {this.state.data["amountBefore"] || "-"}
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["eFAWATEERcom Fees"]} :
                                        </span>
                                        {this.state.data["efwatercomFees"] || "-"}
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["EzPay Fees"]} :
                                        </span>
                                        {this.state.data["ezPayFees"] || "-"}
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["Distributor Fees"]} :
                                        </span>
                                        {this.state.data["distFees"] || "-"}
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["POS Fees"]} :
                                        </span>
                                        {this.state.data["posFees"] || "-"}
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["Amount After"]} :
                                        </span>
                                        {this.state.data["amountAfter"] || "-"}
                                    </Col>
                                </> : <>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["Buy Price"]} :
                                        </span>
                                        {this.state.data["distPrice"] || "-"}
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["Buy Price for POS"]} :
                                        </span>
                                        {this.state.data["posPrice"] || "-"}
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <span className="text-bold mr-2 ml-2">
                                            {Strings["Sell Price"]} :
                                        </span>
                                        {this.state.data["amountAfter"] || "-"}
                                    </Col>

                                </>}

                            </Col>

                        </div>
                    </div>


                </div>
            </div>
        );
    }
}
export default ShowEFAWATEERcomData;
